// IMPORTS
// Modules
import { cloneElement } from 'react';
import $ from 'jquery';
// Assets
import './../scss/OHSList.scss';
import icon_cancel_light from './../icons/cancel_light.svg';
import icon_cancel_dark from './../icons/cancel_dark.svg';


// COMPONENT
export default function OHSList (props) {
   // States and Variables
   const listID = 'ohslist-' + Math.floor(Math.random() * 999999);
   var dragRow = "";
   var dragPosition = 0;

   // Functions
   const showPopup = function (index) {
      props.setPopups({...props.popups, [index]: true});
   }
   const hidePopup = function (index) {
      props.setPopups({...props.popups, [index]: false});
   }
   const dragStart = function (event) {
      dragRow = event.target;
   }
   const dragRun = function (event) {
      event.preventDefault();
      event.dataTransfer.dropEffect = 'move';
      if ((event.target.tagName == "TD") && (event.target.parentNode.parentNode.tagName == "TBODY")) {
         // Build Children Array
         let children = Array.from(event.target.parentNode.parentNode.children);

         // Position Dragged Element
         if (children.indexOf(event.target.parentNode) > children.indexOf(dragRow)) {
            event.target.parentNode.after(dragRow);
         } else {
            event.target.parentNode.before(dragRow);
         }

         // Set Final Position
         dragPosition = children.indexOf(event.target.parentNode);
      }
   }
   const dragEnd = function () {
      // Acquire New Order
      var order = [];
      var i = 1;
      $('#' + listID + '-rows').children().each(function () {
         order.push({
            'id': $(this).data('ohslistdataid'),
            'display_order': i
         });
         i++;
      });

      // Send Back New Order
      props.handleDragging(JSON.stringify({
         order: order
      }));
   }


   // Component
   return (
      <div id={listID} className='ohslist'>
         {props.content ? props.content.length > 0 ? 
            <>
               <table>
                  <thead>
                     <tr>
                        {props.enableDragging && <th className='ohslist-header-dragger'></th>}
                        <th className='ohslist-header-selector'></th>
                        {Object.values(props.content[0]).map(function (header, i) {
                           if ((header.display !== false) && (header.metadata !== true)) {
                              return (
                                 <th key={`ohslist-header-${i}`}>
                                    <p>{header.title}</p>
                                 </th>
                              );
                           }
                        })}
                     </tr>
                  </thead>
                  <tbody id={`${listID}-rows`}>
                     {props.content.map(function (item, i) {
                        // Build OHS Filter attribute
                        var ohsfilter = "";
                        Object.values(item).map(function (subitem) {
                           if ((subitem.display !== false) && (subitem.metadata !== true)) {
                              ohsfilter = ohsfilter + " " + subitem.value;
                           }
                        });

                        // Build rows
                        return (
                           <tr key={`ohslist-item-${i}`} data-ohsfilter={ohsfilter} data-ohslistdataid={item.id.value} draggable={props.enableDragging} onDragStart={(event) => {dragStart(event);}} onDragOver={(event) => {dragRun(event);}} onDragEnd={dragEnd}>
                              {props.enableDragging &&
                                 <td className='ohslist-body-dragger'>
                                    <div>
                                       <div></div>
                                       <div></div>
                                       <div></div>
                                    </div>
                                 </td>
                              }
                              <td className='ohslist-body-selector'>
                                 <div>
                                    <input type='checkbox' className='ohsinput' disabled />
                                 </div>
                              </td>
                              {Object.values(item).map(function (subitem, j) {
                                 if ((subitem.display !== false) && (subitem.metadata !== true)) {
                                    return (
                                       <td key={`ohslist-subitem-${i}-${j}`} onClick={() => {showPopup(i);}}>
                                          <div>
                                             <p>{subitem.value}</p>
                                          </div>
                                       </td>
                                    );
                                 }
                              })}
                           </tr>
                        );
                     })}
                  </tbody>
               </table>
               {props.enableDragging && <p>Drag and drop a row to set the order of the entries (not supported on mobile)</p>}
               {props.template && props.content.map(function (item, i) {
                  return (
                     <OHSListPopup onehive={props.onehive} key={`ohslist-popup-${i}`} index={i} popups={props.popups} hidePopup={hidePopup}>
                        {cloneElement(props.template, {
                           content: item,
                           index: i,
                           showPopup: showPopup,
                           hidePopup: hidePopup
                        })}
                     </OHSListPopup>
                  );
               })}
            </>
         : <p className='ohslist-noitems'>There are no items to display</p> : <p className='ohslist-noitems'>There are no items to display</p>}
      </div>
   );
}

function OHSListPopup (props) {
   // Functions
   const handleEscapeKey = function (e) {
      if (e.key === "Escape") {
         e.preventDefault();
         props.hidePopup(props.index);
      }
   }

   // Component
   return (
      <>
         {props.popups[props.index] &&
            <div className='ohslist-popup' onKeyDown={handleEscapeKey}>
               <div className='ohslist-popup-content'>
                  <div className='ohslist-popup-header'>
                     <p>List Item</p>
                     <img src={props.onehive.theme === props.onehive.themes.light ? icon_cancel_dark : icon_cancel_light} alt='Cancel Icon' onClick={() => {props.hidePopup(props.index);}} />
                  </div>
                  <hr />
                  <div className='ohslist-popup-body'>
                     {props.children}
                  </div>
               </div>
            </div>
         }
      </>
   );
}

export function OHSListDataFormatter (payload, mappings=null) {
   // States and Variables
   var defaults= ['id', 'created_at', 'updated_at', 'display_order'];
   
   // Functions
   const buildObject = function (obj) {
      var parent = {};
      Object.keys(obj).forEach(function (key) {
         if ((mappings !== null) && (Object.keys(mappings).includes(key))) {
            // Perform custom mapping
            parent[key] = {
               'title': String(mappings[key].title),
               'value': obj[key],
               'display': Boolean(mappings[key].display),
               'metadata': mappings[key].metadata ? Boolean(mappings[key].metadata) : false
            }
         } else {
            // Perform default mapping
            if (defaults.includes(String(key))) {
               parent[key] = {
                  'title': String(key),
                  'value': obj[key],
                  'display': false,
                  'metadata': true
               }
            } else {
               parent[key] = {
                  'title': String(key),
                  'value': obj[key],
                  'display': true,
                  'metadata': false
               }
            }
         }
      });
      return parent;
   }

   // Component
   if (payload.length > 0) {
      // Used for building entire data set
      var master = [];
      payload.forEach(function (obj) {
         master.push(buildObject(obj));
      });
      return master;
   } else {
      // Used for returning one entry of data set
      return buildObject(payload);
   }
}